import { useMemo } from "react";
import { PERMISSIONS } from "../utils/permissionCodes";
import { usePermissions } from "./usePermissions";

/** Task CRUD flags from backend permission codes (tasks.view / .create / .update / .delete). */
export function useTaskPermissions() {
  const { hasPermission, hasAnyPermission } = usePermissions();

  const canViewTasks = hasAnyPermission([
    PERMISSIONS.TASKS.VIEW,
    PERMISSIONS.TASKS.CREATE,
    PERMISSIONS.TASKS.UPDATE,
    PERMISSIONS.TASKS.DELETE,
  ]);
  const canCreateTasks = hasPermission(PERMISSIONS.TASKS.CREATE);
  const canUpdateTasks = hasPermission(PERMISSIONS.TASKS.UPDATE);
  const canDeleteTasks = hasPermission(PERMISSIONS.TASKS.DELETE);

  return useMemo(
    () => ({
      canViewTasks,
      canCreateTasks,
      canUpdateTasks,
      canDeleteTasks,
    }),
    [canCreateTasks, canDeleteTasks, canUpdateTasks, canViewTasks],
  );
}
